export default __webpack_public_path__ + "static/media/step-two.3c1a570b.svg";